<script lang="ts">
  export let list;
  export let displayLabel;
  export let linkBase: string = null;

  let showAll: boolean = false;
  let linkText: string;

  let displayList = list;

  const refreshDisplay = () => {
    displayList = showAll ? list : list.slice(0, 5);

    if (list.length > 5) {
      linkText = showAll ? "show less" : "show more...";
    }
  };

  const toggleShowAll = () => {
    showAll = !showAll;
    refreshDisplay();
  };

  refreshDisplay();

</script>

{#if displayList.length}
  <div class="fizz-stack-8 fizz-flex-row-inline-8 fizz-full-width">
    <div class="fizz-flex-row-inline-4">
      <div>
        <span class="fizz-text-strong">{displayLabel}:</span>
        {#each displayList as listItem, i}
          {#if linkBase}
            <a
              href="{linkBase}{listItem.id}"
              data-testid="list-link-{listItem.id}"
              class="fizz-text-inherit">{listItem.name}</a
            >{i + 1 == displayList.length ? "" : ", "}
          {:else}
            {listItem.name}{i + 1 == displayList.length ? "" : ", "}
          {/if}
        {/each}
        {#if linkText}
          <!-- svelte-ignore a11y-invalid-attribute -->
          <a href="#" data-testid="list-expand-toggle" on:click|preventDefault={toggleShowAll}
            >{linkText}</a
          >
        {/if}
      </div>
    </div>
  </div>
{/if}
